import { useContext } from 'react';
import ToastContext from '#/app/providers/ToastProvider/ToastContext';

const useToast = () => {
  return useContext(ToastContext);
};

export default useToast;
